import { initNavigation } from './navigation'

// Main containers for menu/submenu
const submenuContainer = document.querySelector('.submenu-container')
const submenuLeftSide = submenuContainer?.querySelector('.submenu-left-side')
const submenuRightSide = submenuContainer?.querySelector('.submenu-right-side')
const mainHeader = document.querySelector('.main-header')
const submenuBack = mainHeader?.querySelector('.submenu-back')
const main = document.querySelector('main')
const breadcrumb = main?.querySelector('main > section.breadcrumb')

let lastScrollTop = 0 // Last recorded scroll position
let resizeTimeout // Variable for debounce on window resizing

/**
* Sets the height of the main menu to the height of the main header.
* If the window width is greater than 991px, sets the height of the main element
* to the height of the header. Otherwise, sets the fixed value to 80px.
*/
const setMenuHeight = () => {
    const mainElem = document.querySelector('main > section > div') || document.querySelector('main > *')
    if (mainElem && mainHeader) {
        mainElem.style.paddingTop = window.innerWidth > 991 ? `${mainHeader.offsetHeight}px` : '80px'
    }

    // If the menu-light class exists, the menu will have a light variant.
    const section = document.querySelector('main > section')
    if (section && section.classList.contains('menu-light')) {
        document.body.classList.add('menu-light')
    }

    // If is on the page breadcrumb
    if (breadcrumb) {
        mainHeader.classList.add('breadcrumb-bg')

        if (!main.querySelector('.article-detail')) {
            main.classList.add('main-gradient')
        }
    }
}

/**
* A function that responds to scrolling.
* Determines whether the user is scrolling up or down, and adds
* or removes classes on the main header accordingly.
*/
const handleScroll = () => {
    const st = window.scrollY || document.documentElement.scrollTop
    const isScrollingUp = st < lastScrollTop
    if (mainHeader) {
        // Toggle scroll-up class based on scroll position
        mainHeader.classList.toggle('scroll-up', st > 90)

        const showBody = document.querySelector('body.show-body')

        // At a certain scroll position (360px) adds or removes classes
        if (st > 360 && !showBody) {
            mainHeader.classList.toggle('scroll-up', isScrollingUp)
            mainHeader.classList.toggle('scroll-down', !isScrollingUp)
        }
    }
    lastScrollTop = Math.max(st, 0)
}

/**
 * Controls adding or removing classes on an element based on click.
 * @param {HTMLElement} element - The element to add/remove the class to.
 * @param {string} add - The name of the class to add/remove.
 */
const menu = (element, add) => {
    const toggleMenu = document.getElementById('toggleMenu')
    if (toggleMenu) {
        toggleMenu.addEventListener('click', () => {
            element.classList.toggle(add)

            /*
                When closing the mobile menu, all classes and content
                for the left and right sides of the submenu need to be removed
            */
            if (!element.classList.contains('show-body')) {
                submenuContainer.classList.remove('show-submenuContainer')
                submenuContainer.classList.remove('show-right-submenuContainer')
                document.body.classList.remove('no-scroll')
                submenuBack.classList.remove('d-block')
                submenuLeftSide.innerHTML = ''
                submenuRightSide.innerHTML = ''
            }
        })
    }
}

const resetSubmenu = () => {
    submenuContainer.classList.remove('show-submenuContainer')
    submenuContainer.classList.remove('show-right-submenuContainer')
    document.body.classList.remove('no-scroll')
    submenuBack.classList.remove('d-block')
    submenuLeftSide.innerHTML = ''
    submenuRightSide.innerHTML = ''
}

const syncBodyScrollState = () => {
    const hasChildren = submenuLeftSide.hasChildNodes()
    const isNoScroll = document.body.classList.contains('no-scroll')

    if (hasChildren && !isNoScroll) {
        document.body.classList.add('no-scroll')
    }

    if (!hasChildren) {
        document.body.classList.remove('no-scroll')
    }
}

const closeSubmenuWhenClickingOutside = (event) => {
    const isNoScroll = document.body.classList.contains('no-scroll')

    if (mainHeader.contains(event.target) || !isNoScroll) {
        return
    }

    if (window.innerWidth > 992) {
        submenuLeftSide.innerHTML = '' // Closing the left part
    }

    submenuRightSide.innerHTML = '' // Closing the right part
    document.body.classList.remove('no-scroll')
}

/**
* Initializes the menu control.
* Adds the necessary classes to the document body and sets up the submenu control.
*/
const initMenuControl = () => {
    if (!submenuContainer || !submenuLeftSide || !submenuRightSide || !mainHeader || !submenuBack || !main) {
        return
    }

    initNavigation()
    menu(document.body, 'show-body')
    document.querySelector('body').insertAdjacentHTML('afterbegin', `<div class="hide-content"></div>`)

    const navigationLinks = document.querySelectorAll('.page-navigation.container a')
    navigationLinks.forEach(link => {
        const navigationLinksUndermenu = link.nextElementSibling
        link.addEventListener('click', () => {
            if (navigationLinksUndermenu && window.innerWidth < 991) {
                submenuContainer.classList.add('show-submenuContainer')
                submenuBack.classList.add('d-block')
            } else {
                document.body.classList.remove('show-body')
            }
        })
    })

    submenuBack.addEventListener('click', function(e) {
        const submenu = e.target.nextElementSibling

        if (submenu.classList.contains('show-right-submenuContainer')) {
            submenu.classList.remove('show-right-submenuContainer')
            return
        }

        if (submenu.classList.contains('show-submenuContainer')) {
            submenu.classList.remove('show-submenuContainer')
            submenuBack.classList.remove('d-block')
            submenuLeftSide.innerHTML = ''
            submenuRightSide.innerHTML = ''
            return
        }
    })

    window.addEventListener('scroll', handleScroll, { passive: true })
    setMenuHeight()

    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout)
        resizeTimeout = setTimeout(setMenuHeight, 500)
    })

    window.addEventListener('click', event => {
        syncBodyScrollState()
        closeSubmenuWhenClickingOutside(event)
        syncBodyScrollState()
    })
}

export { initMenuControl }
